// This file is auto-generated by @hey-api/openapi-ts

export const CustomerCardTypesEnum = {
    PERSONAL: 'PERSONAL',
    PORTABLE: 'PORTABLE',
    RECLAMATION: 'RECLAMATION',
    VIRTUAL_CARD: 'VIRTUAL_CARD',
    IDENTIFIER: 'IDENTIFIER'
} as const;

export type CustomerCardTypesEnum = typeof CustomerCardTypesEnum[keyof typeof CustomerCardTypesEnum];
